import { render, staticRenderFns } from "./MotoristaUpdate.vue?vue&type=template&id=f4ea11c8&"
import script from "./MotoristaUpdate.vue?vue&type=script&lang=js&"
export * from "./MotoristaUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports